import { MUIDataTableOptions } from "mui-datatables";
import { createTheme } from "@mui/material/styles";

export const tableOptions: MUIDataTableOptions = {
  selectableRowsHeader: false,
  selectableRowsHideCheckboxes: true,
  viewColumns: false,
  print: false,
  download: false,
  filter: false,
  filterType: "textField",
  responsive: "vertical",
};

export const getMuiTheme = () =>
  createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            span: {
              justifyContent: "flex-start !important",
            }
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            width: "fit-content",
            margin: 0,
            padding: 0,
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            display: "flex",
            flexDirection: "column",
          },
        },
      },
      MuiTableBody: {
        styleOverrides: {
          root: {
            td: {
              height: "fit-content",
              margin: 0,
              padding: "3px 10px",
              width: "fit-content",
            },
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            margin: 0,
            padding: 0,
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            padding: "10px",
          },
        },
      },
    },
  });
